// src/components/GlobalLoader.js
import React, { useContext } from "react";
import { LoaderContext } from "../context/LoaderContext";
import "../assets/styles/global-loader.scss"; // optional css file or import styles in your scss

export default function GlobalLoader() {
    const { loading } = useContext(LoaderContext);

    if (!loading) return null;

    return (
        <div className="fsgl-overlay" role="status" aria-live="polite" aria-label="Loading">
            <div className="fsgl-card">
              

                <div className="fsgl-spinner" aria-hidden>
                    <svg className="fsgl-ring" viewBox="0 0 50 50">
                        <circle className="fsgl-ring-bg" cx="25" cy="25" r="20" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="6" />
                        <circle className="fsgl-ring-arc" cx="25" cy="25" r="20" fill="none" stroke="var(--loader-accent)" strokeWidth="6" strokeLinecap="round" />
                    </svg>
                </div>

                <div className="fsgl-text">
                    <div className="fsgl-title">{"Loading..."}</div>
                     </div>
            </div>
        </div>
        // <div className="global-loader-overlay" role="status" aria-live="polite">
        //   <div className="global-loader-inner">
        //     <div className="global-loader-spinner" />
        //     <div className="global-loader-text">Loading...</div>
        //   </div>
        // </div>
    );
}
